import React, { useContext } from "react";
import { AppContext } from "../context/AppProvider";

const useIsLoading = () => {
  return useContext(AppContext).app;
};

export default useIsLoading;
